module.exports = __webpack_public_path__ + "img/transfer_hover_ddaf067.webp";